import VeeValidatePT from './vee-validate_pt'
import VeeValidateFR from './vee-validate_fr'
import VeeValidateEN from './vee-validate_en'

export default {
	locale: 'en',
	dictionary: {
		...VeeValidateEN,
		...VeeValidateFR,
		...VeeValidatePT
	}
}


// WEBPACK FOOTER //
// ./src/i18n/vee-validate/index.js